import Head from "next/head";
import Link from "next/link";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline";
import { BlogListPaginated } from "@/components/BlogListPaginated";
import { Button } from "@/components/Button";
import { getPaginatedPostsForward } from "@/lib/posts";
import { Layout } from "@/components/Layout";
import { PageTitle } from "@/components/PageTitle";
import { SectionContainer } from "@/components/SectionContainer";
import { ExternalLinkIcon } from "@heroicons/react/outline";

export const getStaticProps = async ({ params }) => {
  const posts = await getPaginatedPostsForward(
    false,
    false,
    parseInt(process.env.NEWS_POSTS_PER_PAGE, 10),
    params.cursor,
  );

  return {
    props: { posts },
    revalidate: 60,
  };
};

export const getStaticPaths = async () => {
  let posts = await getPaginatedPostsForward(
    false,
    false,
    parseInt(process.env.NEWS_POSTS_PER_PAGE, 10),
  );
  let pageCursors = [posts.pageInfo.endCursor];

  while (posts.pageInfo.hasNextPage) {
    posts = await getPaginatedPostsForward(
      false,
      false,
      parseInt(process.env.NEWS_POSTS_PER_PAGE, 10),
      posts.pageInfo.endCursor,
    );
    pageCursors.push(posts.pageInfo.endCursor);
  }

  return {
    paths:
      pageCursors.map((cursor) => {
        return `/news/page/${cursor}`;
      }) || [],
    fallback: false,
  };
};

export default function News({ posts: { edges, pageInfo } }) {
  const pageTitle = "News";

  return (
    <>
      <Head>
        <title>{`${pageTitle} - Govern For California`}</title>
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <Layout mobileTitle={pageTitle}>
        <PageTitle title={pageTitle}>
          <div className="mb-12 items-center sm:my-6 sm:flex sm:justify-center lg:justify-start">
            <Button
              variant="outline"
              xhref="https://action.governforcalifornia.org/a/subscribe"
              target="_blank"
              rel="noreferrer"
            >
              <span className="inline-flex items-center">
                Subscribe
                <ExternalLinkIcon
                  className="-mr-1 ml-[3px] h-3"
                  aria-hidden="true"
                />
              </span>
            </Button>
          </div>
        </PageTitle>
        <SectionContainer
          bgColor={"bg-white"}
          pt={"pb-8 pt-0"}
          aria-label="Recent posts from Govern For California"
        >
          <BlogListPaginated posts={edges} />

          {/* Pagination control */}
          <nav className="mt-12 flex items-center justify-between border-t border-gray-200 px-4 sm:px-0">
            {/* <div
              className={`${
                !hasPrevious ? "hidden" : ""
              } -mt-px flex w-0 flex-1`}
            >
              <a
                href="#"
                className="inline-flex items-center border-t-2 border-transparent pt-4 pr-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
              >
                <ArrowLeftIcon
                  className="mr-3 h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
                Previous
              </a>
            </div> */}
            <div
              className={`${
                !pageInfo.hasNextPage ? "hidden" : ""
              } -mt-px flex w-0 flex-1 justify-end`}
            >
              <Link
                href={`/news/page/${pageInfo.endCursor}`}
                className="inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
              >
                Older
                <ArrowRightIcon
                  className="ml-3 h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </Link>
            </div>
          </nav>
        </SectionContainer>
      </Layout>
    </>
  );
}
